import StudentCertifictaeModel from '../Apis/StudentCertifictae'
import Controller from './Controller'

export default class StudentCertifictaeController extends Controller {
  constructor() {
    super(new StudentCertifictaeModel())
  }
  //getUsers
  async getUsers(params) {
    const data = await this.model.getUsers(params)
    return data
}
}
